import module from '../shared.module';

module.factory('UserAccountService', [
  '$resource',
  '$q',
  function ($resource, $q) {
    var login = $resource('/api/login');
    var logout = $resource('/api/logout');

    return {
      login: function (username, password) {
        return login.save({
          username: username,
          password: password,
        }).$promise;
      },
      logout: function () {
        return logout.get().$promise;
      },
      forgotPassword: function (email) {
        return $resource('/api/forgot-password').save({
          email,
        }).$promise;
      },
      changePassword: function (resetToken, username, oldPassword, newPassword) {
        return $resource('/api/change-password').save({
          resetToken: resetToken,
          username: username,
          oldPassword: oldPassword,
          newPassword: newPassword,
        }).$promise;
      },
    };
  },
]);
